import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { StringUtils } from '../utils/stringUtils';
import { ConfigUtils } from '../utils/configUtils';


@Injectable()
export class SignalRService {
  public clientId:string
  private hubConnection: signalR.HubConnection;
  constructor() {
    this.clientId=StringUtils.getUnicKey();
    console.log('entro al constructor SignalRService:', this.clientId)
    let url=ConfigUtils.getStrConfValue("urlSignalR");
    url+='/notificationHub?userId='+this.clientId;

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(url)
      .build();
  }

  async startConnection() {
    this.hubConnection
      .start()
      .then(() => console.log('Conexión SignalR iniciada:',this.clientId))
      .catch(err => {
        if(err && err.message && err.message.includes("is not in the 'Disconnected' state"))
          console.log('Previamente ya se ha establecido la conexión a signalR con el clienID:'+this.clientId);
        else
          console.error('Error en conexión SignalR:', err)
      });
  }

  listenForMessages(callback: (me: any) => void) {
    this.hubConnection.on('ReceiveMessage', callback);
  }
  sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
